<template>
	<div>
		<el-card class="box-card">
			<div slot="header">
				<div class="left">
					<span @click="toBack" style="cursor: pointer">
						<span class="top_title">系统公告</span>
					</span>
					<i class="iconfont">&#xe605;</i>
					<span class="top_title">公告详情</span>
				</div>
			</div>
			<div class="noticeTitle">
				<h3>{{title}}</h3>
				<div class="date">时间：{{edate}} - {{'发布人:'+create}}</div>
			</div>
			<div class="noticeCon" v-html="content">
			</div>
			<el-button class="backbtn" @click="toBack">返回</el-button>
		</el-card>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				title:"",
				edate:"",
				content:"",
				create:"",
			};
		},
		created(){
			let id = this.$route.query.id;
			this.noticeGetDetail(id);
		},
		methods: {
			toBack() {
				this.$router.go(-1);
			},
			noticeGetDetail(id){
				let obj = {
					id:id,
				}
				this.$api.noticeGetDetail(obj).then((res)=>{
					let data = res.data.data;
					this.title = data.title;
					this.edate = data.edate;
					this.content = data.content;
					this.create = data.create;
				})
			}
		},
	};
</script>

<style lang='scss' scoped>

	.left {
		display: flex;
		align-items: center;
		font-size: 16px;

		.iconfont {
			color: #333940;
			font-size: 18px;
		}
	}

	.noticeTitle {
		padding: 10px 20px;
		background: rgba(31, 143, 255, 0.05);
		border-radius: 7px;

		h3 {
			font-size: 16px;
			font-family: Alibaba PuHuiTi;
			font-weight: 400;
			color: #292E33;
			line-height: 30px;
			margin-block-start: 0;
			margin-block-end: 0;
		}
		.date{
			font-size: 14px;
			font-family: Alibaba PuHuiTi;
			font-weight: 400;
			color: rgba(41,46,51,0.62);
		}
	}
	.noticeCon{
		padding: 20px;
		font-size: 16px;
		font-family: Alibaba PuHuiTi;
		font-weight: 400;
		color: #292E33;
	}
	.backbtn{
		margin-left: 20px;
	}
</style>
